import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { RxComponent } from 'app/core/components/common/rx.component';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
import { StepState, StepChange } from 'app/shared/components/happy/happy-stepper/happy-stepper.component';
import { AmberApi } from '../../models/api-helpers';
import { SmartModalService } from 'app/core/services/smart-modal.service';
import { ChildState } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.component';
import { DynamicOnboardingService } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.service';
import { DynamicOnboardingConfigurationService } from 'app/core/components/dynamic-onboarding/dynamic-onboarding-configuration.service';
import { CompleteProfileService } from './complete-profile.service';

@Component({
  selector: 'itpx-complete-profile',
  templateUrl: './complete-profile.component.html',
  styleUrls: ['./complete-profile.component.css']
})

export class CompleteProfileComponent extends RxComponent {
  private stepEnabled: ChildState[];
  // private initState$: Observable<any[]>;
  private stepData: { cardType: string, bucket?: string, key?: string, text?: string, folds: number }[];
  private form: FormGroup;
  private next = new Subject<string>();
  private stepState$: Observable<StepState>;
  private stepClicked$ = new Subject<number>();
  private isFileUploading = false;
  private beforeNext: string[];
  private initialState: StepState = {
    steps: [],
    currentStep: 0,
    previousStep: 0,
    completedStep: 0,
    strictLinearMode: true
  };
  private state: StepState; // = { ...this.initialState };


  constructor(
    private service: CompleteProfileService,
    private fb: FormBuilder,
    private modalService: SmartModalService,
    private onboardingConfigService: DynamicOnboardingConfigurationService
  ) {
    super();
  }

  ngOnInit() {
    this.stepData = this.service.getStepsConfiguration(this.initialState);
    this.stepEnabled = new Array<ChildState>(this.stepData.length).fill(ChildState.disabled);
    this.beforeNext = new Array<string>(this.stepData.length);
    this.stepState$ = this.stepClicked$
      .scan((state, newStep) => StepState.changeStep(state, new StepChange(newStep)), this.initialState)
      .startWith(this.initialState);
    this.state = { ...this.initialState };
    this.stepState$.subscribe(_ => (this.state = _));
    let domainDetails$ = this.service.getDomainDetails();
    let organisationDetails$ = this.service.getOrganizationDetails();
    let logoDetails$ = this.service.getAccountDomain();
    let registerdEmployees$ = this.service.getEmployees();
    let ready$ = Observable.combineLatest(domainDetails$, organisationDetails$, logoDetails$, registerdEmployees$)
      .bindToLifecycle(this)
      .share();
      ready$.subscribe(([domainDetails, organisationDetails, logoDetails, registerdEmployees]) => {
        this.form = this.fb.group({
          watermark: [organisationDetails.watermark],
          domain: [domainDetails.alternatives.find(domain => domain.isDefault).name],
          employees: new FormArray([]),
          logo: [logoDetails.printLogo],
          organisationDetails: [organisationDetails],
          registeredEmployees: [registerdEmployees]
        });
      });
  }
  private proceed(allowed: ChildState, idx: number) {
    switch (allowed) {
      case ChildState.done:
        // const body = { key: this.KEY, step: 'onboarding-' + this.state.steps[this.state.currentStep].key, viewed: true, reminder: true };
        // this.service.setUserGuidance(this.userId, body).bindToLifecycle(this).subscribe(_ =>
        this.stepClicked$.next(this.state.currentStep + 1)
        // );
        this.stepEnabled[idx] = allowed;
        // this.stepEnabled = false;
        break;
      case ChildState.enabled:
      case ChildState.disabled:
        this.stepEnabled[idx] = allowed;
        break;
      // console.log('In proceed');
    }
  }

  ngOnDestroy() {
    this.service.resetAgoraDomain();
    this.service.resetDomain();
    this.service.resetProfile();
  }

  private onNext() {
    this.next.next(this.state.steps[this.state.currentStep].key);
  }

  processMessage(message: { label: string, text: string }, index: number) {
    if ('beforeNext' === message.label) {
      this.beforeNext[index] = message.text;
    } else {
      throw Error(`label ${message.label} not defined`);
    }
  }

  private isCurrentStepValid(): boolean {
    return this.stepEnabled[this.state.currentStep] === ChildState.enabled || this.stepEnabled[this.state.currentStep] === ChildState.done;
  }

  private back() {
    this.stepClicked$.next(this.state.currentStep - 1);
  }

  // private delegate() {
  //   const body = { key: this.KEY, reminder: true, viewed: true, step: 'onboarding-' + this.state.steps[this.state.currentStep].key };
  //   this.service.setUserGuidance(this.userId, body).bindToLifecycle(this).subscribe(_ => this.modalService.sendResult(null));
  // }

  private onFinish() {
    // const body = { key: this.KEY, step: 'onboarding-' + this.state.steps[this.state.currentStep].key, viewed: true, completed: true };
    // this.service.setUserGuidance(this.userId, body).bindToLifecycle(this).subscribe(_ => 
    this.modalService.sendResult(null);
    // );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/complete-profile/complete-profile.component.ts